<main class="company-page">
  <section class="company-card">
    <header class="company-heading">
      <span class="company-heading__caption">
        {{ languageService.translate(['COMPANY', 'КОМПАНИЯ']) }}
      </span>

      <h1>FIRST CLASS<br>SOLUTIONS LIMITED</h1>

      <p>
        {{ languageService.translate([
          'Private travel and premium airport services worldwide',
          'Индивидуальные путешествия и премиальные аэропортовые услуги по всему миру'
        ]) }}
      </p>
    </header>

    <div class="company-rule" aria-hidden="true"><span></span></div>

    <section class="company-primary" aria-label="Company contacts">
      <div class="company-primary__item">
        <span class="company-label">{{ languageService.translate(['ADDRESS', 'АДРЕС']) }}</span>
        <address>
          Office 4, 10/F Kwan Chart Tower,<br>
          No. 6 Tonnochy Rd, Wan Chai, Hong Kong
        </address>
      </div>

      <div class="company-primary__item company-primary__item--phone">
        <span class="company-label">{{ languageService.translate(['PHONE', 'ТЕЛЕФОН']) }}</span>
        <a href="tel:+66991609711">+66 99 160 97 11</a>
      </div>
    </section>

    <section class="company-columns">
      <div class="company-column">
        <span class="company-label">{{ languageService.translate(['LEGAL', 'ДОКУМЕНТЫ']) }}</span>

        <div class="company-links">
          <button type="button">
            <span>{{ languageService.translate(['Cookie Policy', 'Политика использования куки']) }}</span>
            <span class="company-links__arrow">↗</span>
          </button>
          <button type="button">
            <span>{{ languageService.translate(['Privacy Policy', 'Политика конфиденциальности']) }}</span>
            <span class="company-links__arrow">↗</span>
          </button>
          <button type="button">
            <span>{{ languageService.translate(['Public Offer', 'Публичная оферта']) }}</span>
            <span class="company-links__arrow">↗</span>
          </button>
        </div>
      </div>

      <div class="company-column">
        <span class="company-label">{{ languageService.translate(['SOCIAL', 'СОЦИАЛЬНЫЕ СЕТИ']) }}</span>

        <div class="company-links company-links--social">
          <span><span>Telegram</span><span class="company-links__arrow">↗</span></span>
          <span><span>Instagram</span><span class="company-links__arrow">↗</span></span>
          <span><span>WhatsApp</span><span class="company-links__arrow">↗</span></span>
        </div>
      </div>
    </section>

    <footer class="company-footer">
      <span>2026 © First Class Solutions Limited</span>
      <span>BR № 77889104</span>
      <span>IATA TIDS 96223466</span>
    </footer>
  </section>
</main>
